import React from 'react'
import moment from 'moment'
import * as css from './Fondos.css'

let PropTypes = React.PropTypes
moment.locale('es')

export class RowInventarios extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Correlativo */}
                <td className={css.tdIndex} title={this.props.inventario.idInventario}>{this.props.index+1}</td>
                {/* Fecha Programada */}
                <td className={css.tdFecha} >{moment(this.props.inventario.fechaProgramada).format('DD-MM-YYYY')}</td>
                {/* Cliente */}
                <td className={css.tdCliente}>{this.props.inventario.nombreCliente}</td>
                {/* Local */}
                <td className={css.tdLocal}>{this.props.inventario.nombreLocal}</td>
                {/* Comuna */}
                <td className={css.tdComuna}>{this.props.inventario.comuna}</td>
                {/* Region */}
                <td className={css.tdRegion}>{this.props.inventario.region}</td>
                {/* Jornada */}
                <td className={css.tdJornada}>{this.props.inventario.jornada}</td>
                {/* Dotación */}
                <td className={css.tdDotacion}>{this.props.inventario.dotacion}</td>
                {/* Hr Lider */}
                <td className={css.tdHrLider}>{this.props.inventario.hrLider}</td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/asignacion-fondos/RowInventarios.jsx